import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=33992c44&scoped=true"
import script from "./wrap.vue?vue&type=script&lang=js"
export * from "./wrap.vue?vue&type=script&lang=js"
import style0 from "./wrap.vue?vue&type=style&index=0&id=33992c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33992c44",
  null
  
)

export default component.exports